import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exit",
  "use": "exit-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"exit\">\n\t<path d=\"M17.776 8.001H8.053a3 3 0 0 0-3 3v16.222a3 3 0 0 0 3 3h9.723\" stroke=\"currentColor\" stroke-width=\"2\" />\n\t<path d=\"m24.5 29.001 8.5-9.5H15v-1.962h18L24.5 8h2.867L37 18.501l-9.633 10.5H24.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol